import { render, staticRenderFns } from "./selectGoodsBrand.vue?vue&type=template&id=e90e5688"
import script from "./selectGoodsBrand.vue?vue&type=script&lang=js"
export * from "./selectGoodsBrand.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports